/** Numero da Skyenex no formato que o wa.me exige: 55 + DDD + numero. */
export const WHATSAPP = '554120182468'

/** Rotulo do mesmo numero, para exibir. */
export const WHATSAPP_LABEL = '(41) 2018-2468'

export const EMAIL = 'luannerva@skyenex.com.br'
export const INSTAGRAM = 'skyenex_'

/** Endereco do backend. Em desenvolvimento o Vite repassa /api para a 3001. */
export const API = import.meta.env.VITE_API_URL ?? '/api'

/** Monta um link do WhatsApp com a mensagem ja escrita. */
export function linkWhatsApp(mensagem?: string): string {
  const base = `https://wa.me/${WHATSAPP}`
  return mensagem ? `${base}?text=${encodeURIComponent(mensagem)}` : base
}
